import { disableSendButtonDynamically } from './disableSendButtonDynamically';
import i18n from 'FRONTEND/utils/i18n';

export const insertPanelButton = () => {
  const actionPanelEl = document.querySelector('.panel-action');
  if (!actionPanelEl || actionPanelEl.querySelector('.panel-action-bottom')) {
    return;
  }
  const buttonContainer = document.createElement('div');
  buttonContainer.setAttribute('class', 'panel-action-bottom');
  const button = document.createElement('button');
  button.setAttribute('class', 'btn btn-primary');
  const text = i18n._('Send');
  button.innerHTML = `<span class="event-icon" data-icon="send"></span>${text}`;
  actionPanelEl.appendChild(buttonContainer);
  buttonContainer.appendChild(button);
  disableSendButtonDynamically(actionPanelEl, button);
};
